import { AgColDefsI, AgGridI } from "../../ag-grid/ag-grid.model";
import { TextRendererComponent } from "../../ag-grid/text-renderer/text-renderer.component";

export class CommonAgGridDropdown {
}
const NameColumn: AgColDefsI = {
    headerName: "Name",
    headerClass: "px-0 custom-column-group-cell",
    field: "name",
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    cellClass: "custom-column-group-cell ",
    minWidth: 300,
    editable: false,
};

const ShortCode: AgColDefsI = {
    headerName: "Short Code",
    headerClass: "px-0 custom-column-group-cell",
    field: "extra3",
    sortable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams: { isCursor: true },
    cellClass: "custom-column-group-cell ",
    minWidth: 100,
    editable: false,
};

export const ColDefs: AgColDefsI[] = [
    NameColumn,
];
export const ColDefswithShortCode: AgColDefsI[] = [
    NameColumn,
    ShortCode,
];

export const AgGridDataModel: AgGridI = {
    colDefs: ColDefs,
    rowSelection: "multiple",
    columnSettings: true,
    rows: [],
    headerHeight: 28,
    rowHeight: 28,
};

export const AgGridDataModelwithShortCode: AgGridI = {
    colDefs: ColDefswithShortCode,
    rowSelection: "multiple",
    columnSettings: true,
    rows: [],
    headerHeight: 28,
    rowHeight: 28,
};
